import { render, staticRenderFns } from "./FiltroPedidoGerente.vue?vue&type=template&id=37269167&"
import script from "./FiltroPedidoGerente.vue?vue&type=script&lang=js&"
export * from "./FiltroPedidoGerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports